// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/authorization.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.iam.v1.ActorObjectPermissions
 */
export interface ActorObjectPermissions {
    /**
     * @generated from protobuf field: bool read = 1;
     */
    read: boolean;
    /**
     * @generated from protobuf field: bool edit = 2;
     */
    edit: boolean;
    /**
     * @generated from protobuf field: bool delete = 3;
     */
    delete: boolean;
    /**
     * @generated from protobuf field: map<string, bool> extra = 4;
     */
    extra: {
        [key: string]: boolean;
    };
}
// @generated message type with reflection information, may provide speed optimized methods
class ActorObjectPermissions$Type extends MessageType<ActorObjectPermissions> {
    constructor() {
        super("c1.api.iam.v1.ActorObjectPermissions", [
            { no: 1, name: "read", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "edit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "delete", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "extra", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ActorObjectPermissions
 */
export const ActorObjectPermissions = new ActorObjectPermissions$Type();
